import React from "react"
//import I18n from "i18n-js/index.js.erb"
import numeral from "numeral"

class ProductSelect extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00'
    };
	}

	componentDidMount() {
		this.initSelect2()
	}

  initSelect2 () {
    var self = this;

    if (this.refs.products) {
      $(this.refs.products).select2({
        ajax: {
          url: '/admin/products_remote',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 40,
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;

            return {
              results: data.items,
              pagination: {
                more: (params.page * 40) < data.total_count
              }
            };
          },
          cache: true
        },

        allowClear: false,
        escapeMarkup: function (markup) {
          return markup;
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (product) {
          return self.selectedOption(product);
        },
        templateSelection: function (product) {
					return self.selectedOption(product)
        }
      }).on('select2:unselect', function () {
        self.props.onChange(null);
      }).on('select2:select', function (selection) {
        self.props.onChange(selection.params.data);
      });
    }
  }

  render() {
    return (
        <select className="form-control" ref="products" style={{width: '100%', minHeight: 33}}>
          {this.props.product ? <option value={this.props.product.id}>{this.processProduct(this.props.product)}</option> : null}
        </select>
    );
  }

  processProduct(product) {
  	if (!product.loading && product.name) {
  		return product.name
  	}
  }

	selectedOption(product) {
		return `<span>${product.name ? product.name : product.text}`
	}

  formatCurrency(num) {
      return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }

}

export default ProductSelect